<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Keyword (always visible) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Business Name (optional)</h2>
    <div class="filter-list__group-content">
      <input id="serviceRepairName" type="text" class="landing-page__field landing-page__query-field"
             [(ngModel)]="serviceRepairFinderFilter.name" (input)="onNameChange()"
             aria-label="Business Name" autocomplete="off" autocorrect="off"
             [attr.aria-invalid]="nameTooShort ? true : null"
             [attr.aria-describedby]="nameTooShort ? 'serviceRepairNameError' : null">
      <div *ngIf="nameTooShort" id="serviceRepairNameError" class="service-repair-filter__validation-message" role="alert">
        Please enter at least three characters to search by business name.
      </div>
    </div>
  </div>
</div>

<!-- Selected-filter chips: the first few active filters (click a chip to remove it) plus a "+N more" marker,
     so selections stay visible even when every section is collapsed. -->
<div class="filter-list service-repair-filter__chips-wrapper" *ngIf="visibleChips.length > 0">
  <div class="service-repair-filter__chips">
    <button class="service-repair-filter__chip" *ngFor="let chip of visibleChips; trackBy: trackByChip"
            type="button" [title]="chip.label" [attr.aria-label]="'Remove ' + chip.label"
            (click)="onToggleFacet(chip.group, chip.value, false)">
      <span class="service-repair-filter__chip-label">{{ chip.label }}</span>
      <mat-icon class="service-repair-filter__chip-remove">close</mat-icon>
    </button>
    <span class="service-repair-filter__chip-more" *ngIf="overflowCount > 0">+{{ overflowCount }} more</span>
  </div>
</div>

<!-- Collapsible facet sections. There are far more service/repair facets than fit on one screen, so each is
     collapsible and its header shows a badge with the number of selected filters. -->
<div class="filter-list service-repair-filter__sections">
  <div class="filter-list__group" *ngFor="let section of sections">
    <button type="button" class="service-repair-filter__section-header"
            [class.service-repair-filter__section-header--open]="expanded[section.key]"
            [attr.aria-expanded]="expanded[section.key]"
            (click)="toggleSection(section.key)">
      <span class="service-repair-filter__section-title">{{ section.title }}</span>
      <span class="service-repair-filter__section-badge" *ngIf="sectionBadgeCount(section) > 0">{{ sectionBadgeCount(section) }}</span>
      <mat-icon class="service-repair-filter__section-chevron">{{ expanded[section.key] ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div class="service-repair-filter__section-body" *ngIf="expanded[section.key]">
      <div class="filter-list__group-buttonbar">
        <span class="filter-list__group-button" (click)="onSelectAll(section.key, section.options)">Select All</span> |
        <span class="filter-list__group-button" (click)="onClearAll(section.key)">Clear All</span>
      </div>
      <div class="filter-list__group-content service-repair-filter__section-options">
        <div class="filter" *ngFor="let option of section.options">
          <mat-checkbox [checked]="isFacetSelected(section.key, option.value)"
                        (change)="onToggleFacet(section.key, option.value, $event.checked)"
                        [attr.aria-label]="option.label" class="filter__checkbox">
            <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
          </mat-checkbox>
        </div>
      </div>

      <!-- Nested, indented Manufacturers subsection at the bottom of the type section. -->
      <div class="service-repair-filter__subsection" *ngIf="section.manufacturers">
        <button type="button" class="service-repair-filter__subsection-header"
                [class.service-repair-filter__section-header--open]="expanded[section.manufacturers.key]"
                [attr.aria-expanded]="expanded[section.manufacturers.key]"
                (click)="toggleSection(section.manufacturers.key)">
          <span class="service-repair-filter__section-title">{{ section.manufacturers.title }}</span>
          <span class="service-repair-filter__section-badge" *ngIf="selectedCount(section.manufacturers.key) > 0">{{ selectedCount(section.manufacturers.key) }}</span>
          <mat-icon class="service-repair-filter__section-chevron">{{ expanded[section.manufacturers.key] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <div class="service-repair-filter__section-body" *ngIf="expanded[section.manufacturers.key]">
          <div class="filter-list__group-buttonbar">
            <span class="filter-list__group-button" (click)="onSelectAll(section.manufacturers.key, section.manufacturers.options)">Select All</span> |
            <span class="filter-list__group-button" (click)="onClearAll(section.manufacturers.key)">Clear All</span>
          </div>
          <div class="filter-list__group-content service-repair-filter__section-options">
            <div class="filter" *ngFor="let option of section.manufacturers.options">
              <mat-checkbox [checked]="isFacetSelected(section.manufacturers.key, option.value)"
                            (change)="onToggleFacet(section.manufacturers.key, option.value, $event.checked)"
                            [attr.aria-label]="option.label" class="filter__checkbox">
                <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
